import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Aurora } from "./Aurora";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieConsent } from "./CookieConsent";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="App relative">
      <Aurora />
      <div className="relative z-10">
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
      <CookieConsent />
    </div>
  );
};
